import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { PosIntegrationService } from '../../../../../services/pos-integration.service';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-link-square',
  templateUrl: './link-square.component.html',
  styleUrls: ['./link-square.component.scss'],
})
export class LinkSquareComponent implements OnInit {
  @Input() partner;
  @Input() selectedPOS;
  @Input() modal;
  @Output() next = new EventEmitter();
  public busy = true;
  public connected = false;
  public syncing = false;
  public message = null;
  public broadcastChannel = new BroadcastChannel('SQUAREPOS_CHANNEL');
  public win;

  public configurationSaved: boolean = false;
  public companyID: string = '';
  public clientID: string = null;
  public url: string = null;

  constructor(
    public router: Router,
    public activatedRoute: ActivatedRoute,
    private posIntegrationService: PosIntegrationService,
    private translate: TranslateService,
  ) {}

  ngOnInit() {
    this.busy = false;

    this.SaveSettings();
  }

  SaveSettings() {
    this.posIntegrationService
      .savePOSConnection(this.partner.PartnerID, {
        PartnerID: this.partner.PartnerID,
        POSID: 17,
      })
      .subscribe((x) => {
        this.posIntegrationService
          .getOAuthUrl(this.partner.PartnerID, 17)
          .subscribe((url) => {
            this.connectPOS(url);
          });
      });
  }

  connectPOS(url) {
    localStorage.setItem('POSPartnerID', this.partner.PartnerID); //Not Ideal but cant find another easy way to pass this to the other window, and the backend makes it more challenging

    this.busy = true;
    this.connected = false;
    this.message = null;

    this.win = this.launchOAuthPopup(url);
    this.checkWindow();
  }

  launchOAuthPopup(url) {
    var w = window.open(
      url,
      'POSForm',
      'toolbar=0,scrollbars=0,location=0,statusbar=0,menubar=0,resizable=0,width=860,height=720',
    );
    return w;
  }

  checkWindow() {
    setTimeout(() => {
      if (this.win.closed === true) {
        console.log(this.connected);
        this.busy = false;
        this.connected = true;
        console.log(this.connected);
      } else {
        if (!this.connected) {
          console.log('aaaaaa');
          this.checkWindow();
        }
      }
    }, 2000);
  }

  done() {
    //this.next.emit();
  }

  skipToHubtiger() {
    this.router.navigateByUrl('/store/calendar');
  }
}
